module.exports = __webpack_public_path__ + "static/media/macacaoOffMobile.8aa41dda.jpg";